<template>
    <div>
        <!-- Error management -->
        <CustomAlerts :errors="errors"></CustomAlerts>

        <!-- TOP CARD -->
        <div class="card card-custom gutter-b">
            <div class="card-header">
                <div class="card-title">
                    <span class="card-icon">
                        <i class="fas fa-user-friends text-primary"></i>
                    </span>
                    <h3 class="card-label">My Tracked Accounts</h3>
                </div>
            </div>
            <div class="card-body">
                <p>
                    Welcome to
                    <span class="text-success font-weight-bolder">My Tracked Accounts</span>, this
                    module enables you to track as many Instagram accounts as you need to monitor
                    their growth, statistics, and posted content.
                </p>
                <p v-if="myAccounts.length < 1">
                    You're currently not tracking any accounts, use the button below to start adding
                    accounts.
                </p>
                <p v-else>
                    You're currently tracking
                    <span class="text-success font-weight-bolder">
                        <span class="badge badge-success">{{ myAccounts.length }}</span>
                        Instagram Accounts </span
                    >, use the button below to start tracking more accounts.
                </p>
            </div>
            <div class="card-footer">
                <b-button variant="success" @click="openAddModal">Add Instagram Account</b-button>
            </div>
        </div>

        <!-- Preloader -->
        <PagePreloader v-if="!pageIsLoaded">your Tracked Accounts</PagePreloader>

        <!-- ADD ACCOUNT MODAL -->
        <b-modal
            size="lg"
            ref="add-account-modal"
            id="add-account-modal"
            centered
            title="Add new Instagram Account"
        >
            <!-- Error management -->
            <CustomAlerts :errors="modalerrors"></CustomAlerts>

            <!-- Preloader -->
            <PagePreloader v-if="modalisloading">Instagram Account</PagePreloader>

            <form
                method="POST"
                ref="addInstagramAccountForm"
                v-on:submit.prevent="addInstagramAccount"
            >
                <b-form-group
                    label-cols="4"
                    label-cols-lg="2"
                    label="Instagram Account"
                    label-for="input-default"
                >
                    <b-form-input
                        id="instagramaccount"
                        name="instagramaccount"
                        placeholder="Enter the username for the Instagram Account you want to add"
                    ></b-form-input>
                </b-form-group>
                <b-form-group
                    label-cols="4"
                    label-cols-lg="2"
                    label="Type"
                    label-for="input-default"
                >
                    <div class="row">
                        <div class="col-lg-6">
                            <label class="option">
                                <span class="option-control">
                                    <span class="radio">
                                        <input
                                            type="radio"
                                            name="type"
                                            value="personal"
                                            checked="checked"
                                            v-model="selectedMode"
                                        />
                                        <span></span>
                                    </span>
                                </span>
                                <span class="option-label">
                                    <span class="option-head">
                                        <span class="option-title"> Personal Account </span>
                                        <span class="option-focus"> </span>
                                    </span>
                                    <span class="option-body"> For your personal accounts. </span>
                                </span>
                            </label>
                        </div>

                        <div class="col-lg-6">
                            <label class="option">
                                <span class="option-control">
                                    <span class="radio">
                                        <input
                                            type="radio"
                                            name="type"
                                            value="competitor"
                                            v-model="selectedMode"
                                        />
                                        <span></span>
                                    </span>
                                </span>
                                <span class="option-label">
                                    <span class="option-head">
                                        <span class="option-title"> Competitor Account </span>
                                        <span class="option-focus"> </span>
                                    </span>
                                    <span class="option-body">
                                        To keep track of your competition.
                                    </span>
                                </span>
                            </label>
                        </div>
                    </div>
                </b-form-group>
                <b-button type="Submit" class="d-none" :disabled="modalisloading"></b-button>
            </form>

            <template v-slot:modal-footer="{ ok, cancel, hide }">
                <b-button
                    variant="success"
                    @click="addInstagramAccount()"
                    :disabled="modalisloading"
                >
                    Add Instagram Account
                </b-button>
                <!-- Button with custom close trigger value -->
                <b-button variant="outline-secondary" @click="hide()"> Cancel </b-button>
            </template>
        </b-modal>
        <!-- END Modal -->

        <!-- Delete account modal -->
        <b-modal
            ref="modal-delete"
            id="modal-delete"
            centered
            size="lg"
            title="Are you sure you want to stop tracking this account?"
        >
            <!-- Error management -->
            <CustomAlerts :errors="modalerrors"></CustomAlerts>

            <!-- Preloader -->
            <PagePreloader v-if="modalisloading"></PagePreloader>

            <!-- Content -->
            <p class="lead">
                Are you sure you want to stop tracking
                <code>@{{ deletemodal.username }}</code>
            </p>

            <template v-slot:modal-footer="{ ok, cancel, hide }">
                <b-button
                    variant="danger"
                    @click="deleteAccount(deletemodal)"
                    :disabled="modalisloading"
                >
                    Remove Account
                </b-button>
                <b-button variant="outline-secondary" @click="hide()"> Cancel </b-button>
            </template>
        </b-modal>

        <div v-if="myAccounts.length > 0">
            <div class="row">
                <div class="col-xl-6">
                    <div class="row">
                        <div class="col-xl-12">
                            <div class="card card-custom gutter-b">
                                <div class="card-header">
                                    <div class="card-title">
                                        <h3 class="card-label">Personal</h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <transition-group name="list" class="row">
                        <AccountBadge2
                            v-for="account in myAccounts"
                            v-if="account.type == 'personal'"
                            :account="account"
                            :key="account.masterid"
                            type="personal"
                            @getEmitAnalyse="redirectToScanner"
                            @getEmitDelete="openDeleteModal"
                        >
                        </AccountBadge2>
                    </transition-group>
                </div>
                <div class="col-xl-6">
                    <div class="row">
                        <div class="col-xl-12">
                            <div class="card card-custom gutter-b">
                                <div class="card-header">
                                    <div class="card-title">
                                        <h3 class="card-label">Competitors</h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <transition-group name="list" class="row">
                        <AccountBadge2
                            v-for="account in myAccounts"
                            v-if="account.type == 'competitor'"
                            :account="account"
                            :key="account.masterid"
                            type="competitor"
                            @getEmitAnalyse="redirectToScanner"
                            @getEmitDelete="openDeleteModal"
                        >
                        </AccountBadge2>
                    </transition-group>
                </div>
            </div>
            <!-- End row -->
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import "~bootstrap-vue/dist/bootstrap-vue.css";
</style>
<style scoped>
.list-enter-active,
.list-leave-active,
.list-move {
    transition: 500ms cubic-bezier(0.59, 0.12, 0.34, 0.95);
    transition-property: opacity, transform;
}

.list-enter {
    opacity: 0;
    transform: translateX(50px) scaleY(0.5);
}

.list-enter-to {
    opacity: 1;
    transform: translateX(0) scaleY(1);
}

.list-leave-active {
    position: absolute;
}

.list-leave-to {
    opacity: 0;
    transform: scaleY(0);
    transform-origin: center top;
}
</style>

<script>
// Defaults
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import axios from "axios";
// Components
import PagePreloader from "@/view/content/Custom/PagePreloader.vue";
import CustomAlerts from "@/view/content/Custom/CustomAlerts.vue";
import AccountBadge2 from "@/view/content/Custom/AccountBadge2.vue";
// Mixins
import axiosErrorManagement from "@/mixins/axiosErrorManagement";

export default {
    name: "MyAccountsPage",
    mixins: [axiosErrorManagement],
    components: {
        PagePreloader,
        AccountBadge2,
        CustomAlerts,
    },
    data() {
        return {
            // Preloaders
            pageIsLoaded: false,
            searchingForAccount: false,
            modalisloading: false,

            // Accounts managemement
            myAccounts: [],

            // Modal managemement
            selectedMode: "personal",
            isAddAccountButtonDisabled: false,

            // Delete modal
            deletemodal: [],

            // Error mangement
            errors: [],
            modalerrors: [],
        };
    },

    methods: {
        // Get all accounts from API
        getMyAccounts() {
            axios
                .get("accounts")
                .then((response) => {
                    // Make pretty
                    var data = response.data;

                    // Add accounts to array
                    this.myAccounts = response.data;
                })
                .catch((error) => {
                    this.errors.push(this.handleAxiosErrors(error));
                })
                .finally(() => {
                    // Close off preloader
                    this.pageIsLoaded = true;
                });
        },

        // Emitted from child -> Clicked on analyse
        redirectToScanner(account) {
            this.$router.push({
                name: "accountscanner",
                params: { propAccount: account.username },
            });
        },

        // Emitted from child -> Open delete modal
        openDeleteModal(account) {
            this.deletemodal = account;
            this.modalisloading = false;
            this.$refs["modal-delete"].show();
        },

        deleteAccount(account) {
            // Reset errors
            this.modalerrors = [];

            // Set loader
            this.modalisloading = true;

            // Perform GET
            var masterid = account.masterid;

            // Perform query
            axios
                .get("accounts/delete/" + masterid)
                .then((response) => {
                    // Make pretty
                    var data = response.data;

                    // Check status
                    if (data.status == "OK") {
                        // Remove from array
                        var foundkey = this.myAccounts.indexOf(account, 0);
                        this.myAccounts.splice(foundkey, 1);

                        // Add a success message
                        this.errors.push({
                            type: "success",
                            message: "Account successfully removed.",
                        });

                        // Hide modal
                        this.$refs["modal-delete"].hide();
                    }

                    // Add errors
                    if (data.messages.length > 0) {
                        data.messages.forEach((message) => {
                            this.modalerrors.push({
                                type: message.type,
                                message: message.message,
                            });
                        });
                    }
                })
                .catch((error) => {
                    this.modalerrors.push(this.handleAxiosErrors(error));
                })
                .finally(() => {
                    // Close off preloader
                    this.modalisloading = false;
                });
        },

        openAddModal() {
            // Reset errors
            this.modalerrors = [];
            this.modalisloading = false;

            // Open modal
            this.$refs["add-account-modal"].show();
        },

        // Process form
        addInstagramAccount() {
            // Reset errors
            this.modalerrors = [];

            // Set loader
            this.modalisloading = true;

            // Get submission form
            var form = this.$refs["addInstagramAccountForm"];
            // Get variables from form
            var instagramaccount = form.instagramaccount.value;
            var type = form.type.value;

            // Submit form
            axios
                .post("accounts/new", {
                    account: instagramaccount,
                    type: type,
                })
                .then((response) => {
                    // Prettify
                    var data = response.data;

                    // Handle response
                    if (data.status == "OK") {
                        // Update the array with missing variables
                        data.data.type = type;

                        // Add account to MyAccounts
                        this.myAccounts.unshift(data.data);

                        // Show success messages
                        this.errors.push({
                            type: "success",
                            message: "Account added successfully!",
                        });

                        // Close modal
                        this.$refs["add-account-modal"].hide();

                        // Remove errors
                        this.modalerrors = [];
                    }

                    // Do error handling
                    if (data.messages.length > 0) {
                        data.messages.forEach((message) => {
                            this.modalerrors.push({
                                type: message.type,
                                message: message.message,
                            });
                        });
                    }
                })
                .catch((error) => {
                    this.modalerrors.push(this.handleAxiosErrors(error));
                })
                .finally(() => {
                    // Close off preloader
                    this.modalisloading = false;
                });
        },
    },

    mounted() {
        this.getMyAccounts();
        this.$store.dispatch(SET_BREADCRUMB, [
            { title: "My Tracked Accounts", route: "myaccounts" },
        ]);
    },
};
</script>
